define('GameDayCore/GDModel/ValueObjects/Boxscore/BoxTeam',['require','exports','module','../ValueObjectFactory','ensureArray/ensureArray','./BoxPlayer'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
		ensureArray = require('ensureArray/ensureArray');

	VO.create(BoxTeam);

	function BoxTeam($data, $homeAway) {
		var vo = VO.ensureVO(this, BoxTeam),
			data = $data,
			team = $homeAway,
			teamNote,
			teamInfo,
			pitchers = [],
			pitcherTotals = [],
			batters = [],
			batterTotals = [],
			winningP,
			losingP,
			savingP,
			i;
			

		//get the batter
		for (i = 0; i < 2; i++) {
			if (!!!data.batting || data.batting[i].team_flag !== team) {
				continue;
			}

			batterTotals = data.batting[i];
			batters = ensureArray(data.batting[i].batter).map(createBoxPlayer);
			//get the text notes, which may or may not exist in the file
			
			teamNote = data.batting[i].note;
			teamInfo = data.batting[i].text_data;
		}

		//get the pitchers
		for (i = 0; i < 2; i++) {
			if (!!!data.pitching || data.pitching[i].team_flag !== team) {
				continue;
			}

			pitcherTotals = data.pitching[i];
			pitcherTotals.total_ip = Math.floor(data.pitching[i].out / 3) + "." + data.pitching[i].out % 3;
			pitchers = ensureArray(data.pitching[i].pitcher).map(createBoxPlayer);
		}

		//parse out innings pitched stat and figure out win/loss pitcher
		for (i = 0; i < pitchers.length; i++) {
			var out = parseFloat(pitchers[i].out),
				otmp = (out / 3).toString(),
				outstr = otmp.split(".");

			pitchers[i].ip = outstr[0] + "." + (out % 3);

			if (typeof pitchers[i].note === "string") {
				var pNote = pitchers[i].note;

				if (pNote.indexOf("W") !== -1) {
					winningP = pitchers[i];
				} else if (pNote.charAt(1) === "S") {
					savingP = pitchers[i];
				} else if (pNote.indexOf("L") !== -1) {
					losingP = pitchers[i];
				}
			}
		}

		vo.batters = batters || "";
		vo.batterTotals = batterTotals || "";
		vo.pitchers = pitchers || "";
		vo.pitcherTotals = pitcherTotals || "";
		vo.win = winningP || "";
		vo.loss = losingP || "";
		vo.save = savingP || "";
		vo.info = teamNote || "";
		vo.text_data = teamInfo || "";
		vo.homeAway = team || "";
		vo.id = data[$homeAway+'_id'] || "";
	}

	function createBoxPlayer(data){
		var BoxPlayer = require('./BoxPlayer');
		return new BoxPlayer(data);
	}

	return BoxTeam;
});
